export const appSearchIcon = {
  data: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 11.3947H11.71L11.43 11.1247C12.41 9.98465 13 8.50465 13 6.89465C13 3.30465 10.09 0.394653 6.5 0.394653C2.91 0.394653 0 3.30465 0 6.89465C0 10.4847 2.91 13.3947 6.5 13.3947C8.11 13.3947 9.59 12.8047 10.73 11.8247L11 12.1047V12.8947L16 17.8847L17.49 16.3947L12.5 11.3947ZM6.5 11.3947C4.01 11.3947 2 9.38465 2 6.89465C2 4.40465 4.01 2.39465 6.5 2.39465C8.99 2.39465 11 4.40465 11 6.89465C11 9.38465 8.99 11.3947 6.5 11.3947Z" fill="#4F4F4F"/>
</svg>
`,
  name: 'search',
};
